var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361.73 86.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.13,81.81,4.59,54.27a15.66,15.66,0,0,1,0-22.15L32.13,4.59A15.64,15.64,0,0,1,43.2,0H318.53A15.64,15.64,0,0,1,329.6,4.59l27.54,27.53a15.66,15.66,0,0,1,0,22.15L329.6,81.81a15.64,15.64,0,0,1-11.07,4.59H43.2A15.64,15.64,0,0,1,32.13,81.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn);
export default __webpack_public_path__ + "static/media/btn.810ab4355324dca09fa7b971bc61a5d8.svg";
export { ForwardRef as ReactComponent };